/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { searchActions } from './slice';
import { API } from './constants';

/**
 * Get search parameter generator function
 * @param {*} param0
 */
export function* getSearchScenariosGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_SEARCH_SCENARIOS, payload);
    yield put(searchActions.getSearchScenarioDataSucceeded(response));
  } catch (error) {
    yield put(searchActions.getSearchScenarioDataFailed(error?.message));
  }
}
/**
 * Get all scenarios parameter generator function
 * @param {*} param0
 */
export function* getScenariosGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_ALL_SCENARIOS, payload);
    yield put(searchActions.getScenariosSucceeded(response));
  } catch (error) {
    yield put(searchActions.getScenariosFailed(error?.message));
  }
}
/**
 * Get all scenarios parameter generator function
 * @param {*} param0
 */
export function* getFavoriteScenarioGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_FAVORITE_SCENARIOS, payload);
    yield put(searchActions.getFavoriteScenarioSucceeded(response));
  } catch (error) {
    yield put(searchActions.getFavoriteScenarioFailed(error?.message));
  }
}
/**
 * Get all scenarios parameter generator function
 * @param {*} param0
 */
export function* updateFavoriteScenarioGenerator({ payload }) {
  try {
    const response = yield call(request, API.UPDATE_FAVORITE_SCENARIOS, payload);
    yield put(searchActions.updateFavoriteScenarioSucceeded(response));
  } catch (error) {
    yield put(searchActions.updateFavoriteScenarioFailed(error?.message));
  }
}
//
export function* searchSaga() {
  yield takeLatest(searchActions.getSearchScenarioData.type, getSearchScenariosGenerator);
  yield takeLatest(searchActions.getScenarios.type, getScenariosGenerator);
  yield takeLatest(searchActions.getFavoriteScenario.type, getFavoriteScenarioGenerator);
  yield takeLatest(searchActions.updateFavoriteScenario.type, updateFavoriteScenarioGenerator);
}
//
export default searchSaga;
